"use client";

import React from "react";
import "./Diwali.css";

// Deterministic values (no Math.random at render) so SSR and hydration match.
const PARTICLES = Array.from({ length: 22 }, (_, i) => ({
  l: `${(i * 37 + 7) % 97}%`,
  t: `${(i * 53 + 11) % 90}%`,
  s: 5 + (i % 4),
  dur: 9 + (i % 6) * 2,
  del: -((i * 1.7) % 12),
}));

const STARS = Array.from({ length: 9 }, (_, i) => ({
  l: `${(i * 61 + 13) % 94}%`,
  t: `${(i * 29 + 6) % 70}%`,
  s: 15 + (i % 3) * 4,
  del: (i * 0.6) % 3.5,
}));

function BannerDiya({ side }) {
  return (
    <span className={`dw-bdiya dw-bdiya-${side}`}>
      <i className="dw-bdiya-glow" />
      <svg viewBox="0 0 60 44" className="dw-bdiya-svg">
        <path className="dw-flame-s" d="M30 2 C23 11 24 19 30 24 C36 19 37 11 30 2Z" fill="#ffca28" />
        <path className="dw-flame-s dw-flame-in" d="M30 10 C27 15 27 19 30 22 C33 19 33 15 30 10Z" fill="#fffde7" />
        <path d="M5 25 H55 C53 38 42 43 30 43 C18 43 7 38 5 25Z" fill={side === "l" ? "#c62828" : "#e65100"} stroke="#ffb300" strokeWidth="2" />
        <path d="M13 31 H47" stroke="#ffd54f" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    </span>
  );
}

// Sits behind the banner text (see .dw-banner-wrap in Diwali.css), scrolls with the page.
export default function DiwaliBannerDecor() {
  return (
    <div className="dw-banner-layer" aria-hidden="true">
      {PARTICLES.map((p, i) => (
        <i
          key={i}
          className={`dw-particle ${i % 2 ? "dw-s-lg" : ""}`}
          style={{
            left: p.l,
            top: p.t,
            width: p.s,
            height: p.s,
            animationDuration: `${p.dur}s`,
            animationDelay: `${p.del}s`,
          }}
        />
      ))}
      {STARS.map((s, i) => (
        <svg
          key={i}
          viewBox="0 0 20 20"
          className={`dw-star ${i % 2 ? "dw-s-lg" : ""}`}
          style={{ left: s.l, top: s.t, width: s.s, height: s.s, animationDelay: `${s.del}s` }}
        >
          <path d="M10 0 L12 8 L20 10 L12 12 L10 20 L8 12 L0 10 L8 8Z" fill="#ffe082" />
        </svg>
      ))}
      <BannerDiya side="l" />
      <BannerDiya side="r" />
    </div>
  );
}
